import React from 'react';
import { useOrion } from '../context/OrionContext';
import { janela } from '../services/plataforma';
import Icon from './Icon';

// ─────────────────────────────────────────────────────────────────────────────
// Barra de controles da janela — só no desktop.
//
// A janela do Electron é `frame:false`: não tem a barra de título do Windows.
// Esta faz o papel dela, igual à do Nexus: uma faixa de 32px onde a área vazia
// arrasta e os três botões ficam à direita.
//
//   ─  volta ao botão flutuante
//   ▢  alterna entre 82% e 100% da área útil
//   ✕  esconde para a bandeja (não encerra — quem encerra é o menu da bandeja)
// ─────────────────────────────────────────────────────────────────────────────

export default function BarraJanela() {
  const { ehDesktop, maximizado } = useOrion();
  if (!ehDesktop) return null;

  return (
    <div className="electron-titlebar">
      <div className="electron-titlebar-drag" />
      <div className="electron-titlebar-btns">
        <button
          className="titlebar-btn minimize"
          onClick={janela.recolherParaBotao}
          title="Minimizar para botão flutuante"
        >
          ─
        </button>
        <button
          className="titlebar-btn maximize"
          onClick={janela.alternarMaximizado}
          title={maximizado ? 'Restaurar' : 'Maximizar'}
        >
          <Icon name={maximizado ? 'restore' : 'maximize'} size={12} />
        </button>
        <button className="titlebar-btn close" onClick={janela.fechar} title="Fechar">
          <Icon name="x" size={12} />
        </button>
      </div>
    </div>
  );
}
